import Loader from "../ts/declarations/Components.d";

export default function Loading({text = "Carregando..."}) {
  return(
    <Loader type="bubble-scale" bgColor={"#6d6e70"} title={text} color={'#6d6e70'} size={100} />
  );
}